import React from 'react'
import { ActivityCard, ActivityCardItem } from '../../../Common/DesignSystem/ActivityCard'
import { Heading5, P3 } from '../../../Common/DesignSystem/Text'
import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import colours from '../../../Common/DesignSystem/Colours'
import UtilizationCard from "./UtilizationCard"

const VehiclesCard = ({
  isLoading,
  dashboardData,
  windowWidth,
  ...props
}) => {
  return (
    <div className="ds-card" style={windowWidth > 768 ? { margin: 0 } : null}>
      <Heading5 style={{ marginBottom: 8 }}>Vehicles</Heading5>
      <div className="flex-row mobile-col">
        <ActivityCard
          noShadow
          label="Vehicles"
          iconName="Car"
          onClick={() => { props.history.push('/vehicleoverview') }}
          activityCards={[
            <ActivityCardItem
              key="vehicles_card_item"
              loading={isLoading}
              headerValue={dashboardData?.vehiclesInsights?.totalVehicles}
            />
          ]}
        />
        <ActivityCard
          noShadow
          label="New Vehicles"
          iconName="Car"
          activityCards={[
            <ActivityCardItem
              key="new_vehicles_card_item"
              loading={isLoading}
              headerValue={dashboardData?.vehiclesInsights?.newVehicles}
              labelValue="Annual Average"
              subValue={dashboardData?.annualVehicleInsights?.newVehicles}
            />
          ]}
        />
        <ActivityCard
          noShadow
          label="Damaged Vehicles"
          iconName="CarDamage"
          activityCards={[
            <ActivityCardItem
              key="damaged_vehicles_card_item"
              loading={isLoading}
              headerValue={dashboardData?.vehiclesInsights?.damagedVehicles}
              labelValue="Annual Average"
              subValue={dashboardData?.annualVehicleInsights?.damagedVehicles}
            />
          ]}
        />
      </div>
      <div className="flex-row mobile-col">
        <ActivityCard
          noShadow
          label="Highest Mileage"
          iconName="Mileage"
          onClick={() => { props.history.push('/vehicleoverview?sort=mileage&sort_direction=desc') }}
          activityCards={[
            <ActivityCardItem
              key="highest_mileage_card_item"
              loading={isLoading}
              headerValue={new Intl.NumberFormat().format(dashboardData?.vehiclesInsights?.highestMileage) + " KM"}
              labelValue="Annual Average"
              subValue={new Intl.NumberFormat().format(Math.round(dashboardData?.annualVehicleInsights?.highestMileage)) + " KM"}
            />
          ]}
        />
        <ActivityCard
          noShadow
          label="Avg Utilization"
          iconName="UtilizationHigh"
          onClick={() => { props.history.push('/vehicleoverview?sort=utilization&sort_direction=desc') }}
          activityCards={[
            <ActivityCardItem
              key="avg_util_card_item"
              loading={isLoading}
              headerValue={Math.round(dashboardData?.vehiclesInsights?.averageUtilization * 100) + '%'}
              labelValue="Annual Average"
              subValue={Math.round(dashboardData?.annualVehicleInsights?.averageUtilization * 100) + '%'}
            />
          ]}
        />
      </div>
      <div style={{ marginTop: 16, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
        <P3 style={{ color: colours.primary.grey02, marginBottom: 8 }}>Monthly Utilization</P3>
        <ResponsiveContainer width={'100%'} height={240}>
          <AreaChart data={dashboardData?.monthlyVehiclesUtilizations}
          >
            <defs>
              <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={colours.primary.blue} stopOpacity={0.16} />
                <stop offset="95%" stopColor={colours.primary.blue} stopOpacity={0.01} />
              </linearGradient>
            </defs>
            <XAxis dataKey="name" tick={{ fontSize: '8px', fontWeight: 'bold' }} />
            <YAxis domain={[0, 100]} scale="linear" unit="%" tick={{ fontSize: '8px', fontWeight: 'bold' }} />
            <Tooltip formatter={(value, name, props) => [value + '%', 'Utilization']} />
            <CartesianGrid vertical={false} stroke="#ccc" strokeDasharray='5 5' />
            <Area type="monotone" dataKey="value" stroke={colours.primary.blue} strokeWidth={2} fillOpacity={1} fill="url(#colorPv)" />
          </AreaChart>
        </ResponsiveContainer>
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
        <UtilizationCard
          type="highest"
          utilizationData={dashboardData?.highestUtilizationVehicles}
          {...props}
        />
        <UtilizationCard
          type="lowest"
          utilizationData={dashboardData?.lowestUtilizationVehicles}
          {...props}
        />
      </div>
    </div>
  )
}

export default VehiclesCard